import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IOversignTime } from './IOversignTime';
import { IGenericResponse } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class OversignTimeService {

  constructor(
    private http: HttpClient,
    private log: LoggingService
    ) { }

  private uri = `${environment.apiLocation}/TimeCardOversign`;
  public getOversignTime( EmployeeListID: string ): Observable<Array<IOversignTime>> {
    return this.http.post<Array<IOversignTime>>(this.uri, { EmployeeListID })
        .pipe(
            tap(data =>
                this.log.verbose({ type: 'OversignTimeService:getOversignTime', data })
            )
        );
  }
  public putOversignTime(oversignData: Array<IOversignTime>): Observable<IGenericResponse<IOversignTime>> {
    return this.http.put<IGenericResponse<IOversignTime>>(this.uri, { TimeCardOversignList: oversignData })
        .pipe(
            tap(data =>
                this.log.verbose({
                    type: 'OversignTimeService:putOversignTime',
                    data
                })
            )
        );
}
}
